import { compileString } from 'sass';
import {AuthModel} from './_models'
import Cookies from 'js-cookie';
const AUTH_LOCAL_STORAGE_KEY = 'accessToken'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  // const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  const lsValue: any | null = Cookies.get(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = {accessToken:lsValue} as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth.result.accessToken)
    // localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    Cookies.set(AUTH_LOCAL_STORAGE_KEY, auth.result.accessToken, { expires: 7 });
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    // localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    Cookies.remove(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.accessToken) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
